
import ApplicationTitle from '../../components/ApplicationTitle';
import TextInput from '../../components/input_fields/TextInput';
import SelectInput from '../../components/input_fields/SelectInput';
import Terms from '../../components/Terms';
import TwoInputs from '../../components/input_fields/TwoInputs'
import StackedTitle from '../../components/form_titles/StackedTitle';
import MainButton from '../../components/buttons/MainButton';
import validator from "validator";
import React, { useState } from "react";
import ProgressBar from '../../components/progress/ProgressBar';
import SearchableSelect from '../../components/input_fields/SearchableSelect';

// Logos
import BipsyLogo from '../../img/BipsyPay/Bipsy.png'
import CoastalLogo from '../../img/Coastal/CoastalLogo.png'

export default function Step1({ nextStep, nextHalfStep, handleFormData, values, validation, formLogo, color }) {

    const [phoneError, setPhoneError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [busError, setBusError] = useState(false)
    const [fnameError, setfnameError] = useState(false)
    const [lnameError, setlnameError] = useState(false)
    const [contactError, setContactError] = useState(false)
    const [legalError, setLegalError] = useState(false)

    const submitFormData = (e) => {

        e.preventDefault();

        if (validation) {
            // Bussiness Name Errors
            if (!validator.isAlphanumeric(values.bussinessName, 'en-US', { ignore: ' \&-' })) {
                setBusError(true)
                return
            } setBusError(false)

            //fname Errors
            if (validator.isEmpty(values.ownerFName)) {
                setfnameError(true)
                return
            } setfnameError(false)

            //lname Errors
            if (validator.isEmpty(values.ownerLName)) {
                setlnameError(true)
                return
            } setlnameError(false)

            // Phone Errors
            if (!validator.isMobilePhone(values.telephoneNumber)) {
                setPhoneError(true)
                return
            } setPhoneError(false)

            // Email Errors
            if (!validator.isEmail(values.emailAddress)) {
                setEmailError(true)
                return
            } setEmailError(false)

            // Contact Errors
            if (validator.isEmpty(values.isPrimaryContact)) {
                setContactError(true)
                return
            } setContactError(false)

            // Legal Errors
            if (validator.isEmpty(toString(values.legal))) {
                setLegalError(true)
                return
            }
            if (values.legal === false || values.legal === "") {
                setLegalError(true)
                return
            } setLegalError(false)
        }


        // Make sure to check all validation BEFORE running this *** 
        if (values.isPrimaryContact === 'no' && values.legal === true) {
            nextHalfStep()
        }
        if (values.isPrimaryContact === 'yes' && values.legal === true) {
            nextStep()
        }
    };

    return (
        <div className="bg-white-900 dark:bg-white-900 w-full">
            <div className="items-center px-8 py-8 my-10 mx-auto w-fit">
                <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                    {formLogo ? (
                        <div className="mt-2">
                            <img className={formLogo[1]} src={formLogo[0]} />
                        </div>
                    ) : (

                        <div className="mt-2">
                            <img className="h-16" src={BipsyLogo} />
                        </div>
                    )}
                </div>
                <ApplicationTitle
                    mainTitle="Merchant Application"
                    subTitle="Complete the form below to begin your merchant application"
                />
                <ProgressBar
                    progress="12%"
                    color = {color}
                />
                <div className="bg-white rounded-lg shadow dark:border">
                    <div className="p-6 space-y-1 sm:p-8">
                        <StackedTitle
                            color = {color}
                            mainTitle="Welcome! Let's create"
                            colorTitle="your account."
                            subText="We just need some basic information about your business to get started."
                        />
                        <form className="space-y-4 " onSubmit={submitFormData}>
                            <TwoInputs
                                color = {color}
                                placeholder1="Business Name" id1="business_name" type1="Text" name1="bussinessName" value1={values.bussinessName}
                                error1={busError} message1="Please enter a business name"
                                handleInputChange1={handleFormData}
                                placeholder2="DBA Name" id2="dba_name" type2="Text" name2="tradeName" value2={values.tradeName}
                                handleInputChange2={handleFormData}
                            />

                            <TwoInputs
                                color = {color}
                                placeholder1="Owner First Name" id1="first_name" type1="Text" name1="ownerFName" value1={values.ownerFName}
                                error1={fnameError} message1="Please enter your first name"
                                handleInputChange1={handleFormData}
                                placeholder2="Owner Last Name" id2="last_name" type2="Text" name2="ownerFName" value2={values.ownerLName}
                                error2={lnameError} message2="Please enter your last name"
                                handleInputChange2={handleFormData}
                            />

                            <TextInput 
                                color = {color}
                                placeholder="Phone Number" name="telephoneNumber" value={values.telephoneNumber}
                                error={phoneError} message="Please enter a valid phone number"
                                handleInputChange={handleFormData} 
                            />

                            <TextInput 
                                color = {color}
                                placeholder="Email" name="emailAddress" value={values.emailAddress}
                                error={emailError} message="Please enter a valid email"
                                handleInputChange={handleFormData} 
                            />

                            <SelectInput 
                                color = {color}
                                placeholder="Will this person be the primary contact for the account?" name="isPrimaryContact" options={["yes", "no"]} value={values.isPrimaryContact}
                                error={contactError} message="Will this person be the primary contact for the account?"
                                handleInputChange={handleFormData} 
                            />

                            <Terms name="legal" color = {color} error={legalError} message="Read and agree to our terms to continue" value={values.legal}
                                handleInputChange={handleFormData} />

                            <MainButton text="Next" color = {color}></MainButton>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}